/* eslint-disable react-refresh/only-export-components */
import type {ReactElement} from 'react';
import type {EmailMakerControl} from '../../right-panel-registry.types';
import {createDescriptorControl} from '../create-descriptor-control';
import {InfoBox} from './components/info-box/info-box';
import type {InfoBoxControlInnerProps, InfoBoxDescriptor} from './info-box-control.types';
import styles from './info-box-control.module.scss';

export const COLLAPSIBLE_CONTROL_SET = new WeakSet<EmailMakerControl>();

function InfoBoxControlInner({descriptor}: InfoBoxControlInnerProps): ReactElement {
  return (
    <div className={styles.wrapper}>
      <InfoBox descriptor={descriptor} />
    </div>
  );
}

export function makeInfoBoxControl(descriptor: InfoBoxDescriptor): EmailMakerControl {
  return createDescriptorControl(InfoBoxControlInner, descriptor);
}
